"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { MapPin, CircleCheck as CheckCircle2, ArrowRight, ShieldCheck, Sparkles, Calendar, Phone, TrendingUp, UserCheck } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const trustPoints = [{
  id: 1,
  text: "Direct 1-on-1 access to Yassine Essaadi—no junior account managers"
}, {
  id: 2,
  text: "Custom local strategy tailored specifically for Derby & Midlands markets"
}, {
  id: 3,
  text: "Transparent reporting with actionable, clear search growth deliverables"
}, {
  id: 4,
  text: "Google Maps, Local Pack, and organic search optimization"
}];
const highlights = [{
  id: 1,
  label: "SEO Focus",
  value: "Local & National"
}, {
  id: 2,
  label: "Consultant",
  value: "100% Direct Access"
}, {
  id: 3,
  label: "Location",
  value: "Derby & UK Wide"
}];
export default function LocalHero() {
  return <section id="localherotrust" data-nav="dark" className="relative min-h-[85vh] w-full flex items-center bg-primary text-primary-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      {}
      <div aria-hidden="true" className="absolute top-0 right-0 -mt-12 -mr-12 size-96 rounded-full bg-accent/20 blur-3xl pointer-events-none" />
      <div aria-hidden="true" className="absolute bottom-0 left-0 -mb-16 -ml-16 size-80 rounded-full bg-secondary/15 blur-2xl pointer-events-none" />
      
      {}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col items-start space-y-6">
            
            {}
            <Badge variant="secondary" className="bg-secondary/90 text-secondary-foreground hover:bg-secondary border border-secondary-foreground/10 px-3.5 py-1.5 text-xs sm:text-sm font-medium rounded-full flex items-center gap-2 shadow-xs">
              <MapPin className="size-4 text-accent" />
              <span>Independent Local SEO Consultant in Derby</span>
            </Badge>

            {}
            <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-primary-foreground leading-[1.15]">
              Local SEO Consultant in Derby for Sustainable Search Growth
            </h1>

            {}
            <p className="font-sans text-base sm:text-lg text-primary-foreground/90 max-w-2xl leading-relaxed">
              I help Derby and East Midlands businesses dominate local search, attract high-intent customers, and build lasting organic visibility. When you partner with YE Consultancy, you work directly with me—Yassine Essaadi. No agency fluff, no junior account managers, just practical, expert-led SEO strategy.
            </p>

            {}
            <div className="w-full pt-2 pb-2">
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {trustPoints.map((point, i) => <li key={point.id} data-index={i} className="flex items-start gap-2.5 text-sm sm:text-base text-primary-foreground/95">
                    <CheckCircle2 className="size-5 text-accent shrink-0 mt-0.5" />
                    <span>{point.text}</span>
                  </li>)}
              </ul>
            </div>

            {}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 w-full sm:w-auto pt-2">
              <Button asChild size="lg" className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold h-13 px-8 text-base rounded-lg shadow-md transition-all group">
                <Link to="/ContactPage">
                  <span>Book a Free SEO Consultation</span>
                  <ArrowRight className="size-5 ml-2 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="border-primary-foreground/30 bg-primary-foreground/5 hover:bg-primary-foreground/15 text-primary-foreground h-13 px-8 text-base rounded-lg transition-all">
                <Link to="/CaseStudiesPage">
                  <span>Explore My Case Studies</span>
                </Link>
              </Button>
            </div>

            {}
            <div className="flex items-center gap-2 pt-2 text-xs sm:text-sm text-primary-foreground/80">
              <Phone className="size-4 text-accent" />
              <span>Direct Client Line:</span>
              <a href="tel:+447490984430" className="font-semibold text-primary-foreground hover:underline">
                +44 7490984430
              </a>
            </div>

          </div>

          {}
          <div className="lg:col-span-5 w-full max-w-md mx-auto lg:max-w-none">
            <div className="relative rounded-2xl bg-card text-card-foreground p-6 sm:p-8 shadow-2xl border border-border">
              
              {}
              <div className="flex items-center gap-4 pb-6 border-b border-border">
                <div className="relative shrink-0">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/yassine_essaadi_seo_consultant.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/yassine_essaadi_seo_consultant.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/yassine_essaadi_seo_consultant.webp-wvc-sizes" alt="Yassine Essaadi - Local SEO Consultant" loading="lazy" decoding="async" className="size-20 sm:size-24 rounded-full object-cover border-2 border-primary shadow-sm" />
                  <span className="absolute bottom-0 right-0 size-5 bg-emerald-500 border-2 border-card rounded-full" title="Available for new client consultations" />
                </div>
                <div>
                  <div className="flex items-center gap-1.5 text-xs font-semibold text-primary uppercase tracking-wider">
                    <UserCheck className="size-3.5" />
                    <span>Lead Consultant</span>
                  </div>
                  <h2 className="font-serif text-xl sm:text-2xl font-bold text-card-foreground">
                    Yassine Essaadi
                  </h2>
                  <p className="text-xs sm:text-sm text-muted-foreground mt-0.5">
                    Founder & Senior SEO Strategist at YE Consultancy
                  </p>
                </div>
              </div>

              {}
              <div className="py-5 space-y-3">
                <div className="flex items-center gap-2 text-sm font-semibold text-card-foreground">
                  <ShieldCheck className="size-4 text-primary" />
                  <span>The Direct Consultant Advantage</span>
                </div>
                <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                  "I work directly with ambitious business owners in Derby and across the UK. You get complete transparency, bespoke strategies, and direct communication every single step of the way."
                </p>
              </div>

              {}
              <div className="grid grid-cols-3 gap-2 py-4 my-2 bg-muted/60 rounded-xl p-3 border border-border/50 text-center">
                {highlights.map((item, i) => <div key={item.id} data-index={i} className="flex flex-col items-center justify-center p-1">
                    <span className="text-xs text-muted-foreground">{item.label}</span>
                    <span className="text-xs sm:text-sm font-bold text-card-foreground mt-0.5">{item.value}</span>
                  </div>)}
              </div>

              {}
              <div className="pt-4 mt-2 border-t border-border flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <SafeHydrate><Calendar className="size-4 text-accent shrink-0" /></SafeHydrate>
                  <span>Free 30-Min Strategy Call</span>
                </div>
                <Button asChild size="sm" variant="default" className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium text-xs rounded-md shadow-xs">
                  <Link to="/ContactPage">
                    <span>Book Call</span>
                  </Link>
                </Button>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>;
}